import { createActionConst } from '../../../utils/action.utils';

const COMPANY_TOOLS_CATEGORY_NAMESPACE = 'COMPANY_TOOLS_CATEGORY';

export const STORE_COMPANY_TOOLS_CATEGORY = createActionConst(
  COMPANY_TOOLS_CATEGORY_NAMESPACE,
  'STORE_COMPANY_TOOLS_CATEGORY',
);
export const CLEAR_COMPANY_TOOLS_CATEGORY = createActionConst(
  COMPANY_TOOLS_CATEGORY_NAMESPACE,
  'CLEAR_COMPANY_TOOLS_CATEGORY',
);
